import React from "react";
import { Alert, Box, Checkbox, CircularProgress, FormControlLabel, Typography } from "@mui/material";
import { normalizeIdArray } from "../utils/companyUtils";

const MAX_CUISINES = 5;

export default function SectionKuechen({
                                           form,
                                           setForm,
                                           cuisines,
                                           cuisinesLoading,
                                           cuisinesError,
                                       }) {
    const [limitError, setLimitError] = React.useState("");

    const activeCuisines = React.useMemo(
        () => (cuisines || []).filter((cuisine) => cuisine.is_active === undefined || !!cuisine.is_active),
        [cuisines]
    );

    const selectedIds = normalizeIdArray(form.cuisine_ids);

    const toggleCuisine = (id) => {
        setForm((f) => {
            const ids = new Set(normalizeIdArray(f.cuisine_ids));
            if (ids.has(id)) {
                ids.delete(id);
                setLimitError("");
            } else {
                if (ids.size >= MAX_CUISINES) {
                    setLimitError(`Es dürfen maximal ${MAX_CUISINES} Küchen ausgewählt werden.`);
                    return f;
                }
                ids.add(id);
                setLimitError("");
            }
            return { ...f, cuisine_ids: Array.from(ids).sort((a, b) => a - b) };
        });
    };

    if (cuisinesError) {
        return <Alert severity="error">{cuisinesError}</Alert>;
    }

    if (cuisinesLoading) {
        return (
            <Box sx={{ py: 2, textAlign: "center" }}>
                <CircularProgress size={20} />
            </Box>
        );
    }

    if (!activeCuisines.length) {
        return <Alert severity="info">Keine Küchen vorhanden. Lege zuerst Küchen an.</Alert>;
    }

    return (
        <Box>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
                {selectedIds.length} von {MAX_CUISINES} ausgewählt
            </Typography>

            {limitError && <Alert severity="warning" sx={{ mb: 1 }}>{limitError}</Alert>}

            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, minmax(0, 1fr))",
                        md: "repeat(3, minmax(0, 1fr))",
                        lg: "repeat(4, minmax(0, 1fr))",
                    },
                    gap: 0.25,
                    maxHeight: 260,
                    overflowY: "auto",
                    pr: 1,
                    py: 0.5,
                }}
            >
                {activeCuisines.map((cuisine) => {
                    const id = Number(cuisine.id);
                    const checked = selectedIds.includes(id);
                    const label = cuisine.label_de || cuisine.name;
                    return (
                        <FormControlLabel
                            key={cuisine.id}
                            control={
                                <Checkbox
                                    size="small"
                                    checked={checked}
                                    onChange={() => toggleCuisine(id)}
                                    sx={{ py: 0.5 }}
                                />
                            }
                            label={label}
                            sx={{
                                m: 0,
                                minWidth: 0,
                                borderRadius: 1,
                                px: 0.75,
                                py: 0.25,
                                bgcolor: checked ? "rgba(240, 172, 77, 0.10)" : "transparent",
                                "&:hover": { bgcolor: "action.hover" },
                                "& .MuiFormControlLabel-label": {
                                    fontSize: "0.875rem",
                                    lineHeight: 1.25,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                },
                            }}
                        />
                    );
                })}
            </Box>
        </Box>
    );
}
